import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import api from 'api';
import Util from 'utility.js';
import { addMeal, addTraining, setProfileData } from 'actions/index';

function LectureIntro() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        Util.setPageTitle('Úkol');
        const lectureId = data.appModeData.lectureId;

        api('lecturetask/info/' + lectureId).then(result => {
            if (result.data.profile !== false) {
                dispatch(setProfileData({ id: result.data.profile.id, data: result.data.profile }));
            }

            const lectureInfo = result.data;
            const lectureData = lectureInfo.lecture_data;

            if (Array.isArray(lectureData.meal_types)) {
                lectureData.meal_types.forEach(m => {
                    const t = m.time.split(':');
                    dispatch(addMeal({
                        mealId: m.type * 1,
                        mealLength: 0,
                        startHour: t[0] * 1,
                        startMinute: t[1] * 1,
                        profiles: [Util.getActiveProfileId()]
                    }));
                });
            }

            if (Array.isArray(lectureData.activity_types)) {
                lectureData.activity_types.forEach(a => {
                    if (a.time === '' || a.length === '') return;
                    const t = a.time.split(':');
                    dispatch(addTraining({
                        start: t[0] + ':' + t[1],
                        length: a.length,
                        description: a.title,
                        profiles: [Util.getActiveProfileId()]
                    }));
                });
            }

            const currentDate = new Date('2000-01-01');
            const saveData = JSON.stringify({
                titles: JSON.stringify(data.titles),
                meals: JSON.stringify(data.meals),
                foods: JSON.stringify(data.foods),
                groups: JSON.stringify(data.foodGroups),
                modifications: JSON.stringify(data.modifications),
                activities: JSON.stringify(data.activities),
                trainings: JSON.stringify(data.trainings),
                dayTimestamp: Math.floor(currentDate.getTime() / 1000),
                energyOutputSettings: JSON.stringify(data.energyOutputSettings)
            });

            api('save/dayplan', { post: true, data: saveData }).then(() => {
                const swData = lectureInfo?.seminar_work_data;
                if (swData && swData.is_assignment === 1) {
                    const dayIds = Object.keys(swData.lectures);
                    history.push('/load/seminarwork-task/' + dayIds[0]);
                } else {
                    history.push('/plan');
                }
            });
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}

export default LectureIntro;
